import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class HomeService {

  public endpoint: string = environment.backend;
  public header: any;
  public api: string;
  public domain: string = 'home/';

  constructor(public http: HttpClient, public resource: string) {
    this.header = { headers: new HttpHeaders().set(environment.atoken, this.getToken()) };
    this.api = this.endpoint + this.domain + this.resource;
  }

  private getToken() {
    let uss: any = JSON.parse(sessionStorage.getItem(environment.atoken));
    return uss != null ? uss.token : '';
  }

  private add(api, id) {
    return api + '/' + id;
  }

  public get() {
    return this.http.get(this.api, this.header);
  }

  public post(data) {
    return this.http.post(this.api, data, this.header);
  }

  public put(id, data) {
    return this.http.put(this.add(this.api, id), data, this.header);
  }

  public del(id) {
    return this.http.delete(this.add(this.api, id), this.header);
  }

  public dropdown(obj) {
    return this.http.get(this.api.replace(this.resource, obj) + '/dropdown', this.header);
  }
}